import React, { useEffect, useState } from "react";
import {Outlet, } from "react-router-dom";
import ProfileDetails from '../profile/profileDetails';

function Profile() {  
  useEffect (() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Outlet />
    </div>

  );
}

export default Profile;